<template>
  <div>
    <MyStudents403Forbidden v-if="!(hasAdvisorInstitutionPermission && hasAnyTableauLevelPermission)" />
    <div v-else class="bg-blue-100 text-sm text-indigo-base">
      <div class="mx-5">
        <div class="flex flex-col items-baseline justify-between" :style="{ height: `${TABLEAU_PAGE_HEIGHT}px` }">
          <VizLoader :key="selectedEntity.id" :src="interestedStudentsReportSource" :filters="filters" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import MyStudents403Forbidden from "@/components/MyStudentDetail/MyStudents403Forbidden.vue";
import VizLoader from "@/components/VizLoader/index.vue";
import { hasAdvisorInstitutionPermission, hasAnyTableauLevelPermission } from "@/composables/authorization";
import { interestedStudentsReportSource } from "@/composables/tableau.js";
import { useTenantEntityManager } from "@/composables/useTenantManager.js";
import { TABLEAU_PAGE_HEIGHT } from "@/constants.js";
import { computed } from "vue";

defineOptions({ name: "InterestedStudentsReport" });

const { getSelectedEntityView } = useTenantEntityManager();
const selectedEntity = getSelectedEntityView;

const filters = computed(() => [
  {
    name: "ENTITY_ID",
    value: selectedEntity.value.id,
  },
]);
</script>
